import * as tslib_1 from "tslib";
import { map, takeUntil } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import * as account from '../../actions/account';
import * as fromAuth from '../../reducers';
import { ContainerBase } from '../../../core/base/container-base';
var ResetPasswordContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ResetPasswordContainer, _super);
    function ResetPasswordContainer(store, route, translate) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.route = route;
        _this.translate = translate;
        _this.submitting$ = store.pipe(select(fromAuth.isResetting), takeUntil(_this.destroyed$));
        _this.error$ = store.pipe(select(fromAuth.getResetError), takeUntil(_this.destroyed$));
        _this.isResetLinkValidationCompleted$ = _this.store.pipe(select(fromAuth.isResetTokenValidationCompleted), takeUntil(_this.destroyed$));
        _this.isResetLinkValid$ = _this.store.pipe(select(fromAuth.isResetTokenValid), takeUntil(_this.destroyed$));
        _this.store.pipe(select(fromAuth.getPageLanguage), takeUntil(_this.destroyed$))
            .subscribe(function (language) {
            if (language) {
                if (language) {
                    _this.translate.use(language);
                }
                else {
                    _this.translate.use(translate.getBrowserLang());
                }
            }
        });
        return _this;
        // remove header space
        //this.store.dispatch(new status.SetHeader(false));
        // this.submit$.pipe(
        //   withLatestFrom(
        //     route.params.pipe(map(param => param['token'])),
        //     (password, token) => (<ResetRequest>{
        //       password,
        //       token
        //     })
        //   ),
        //   map(request => new account.Reset(request)))
        //   .subscribe(store)
    }
    ResetPasswordContainer.prototype.ngOnInit = function () {
        var _this = this;
        this.store.dispatch(new account.ResetClear());
        this.route.params.pipe(map(function (param) { return param['token']; }), takeUntil(this.destroyed$))
            .subscribe(function (token) {
            _this.token = token;
            _this.store.dispatch(new account.ValidateResetLink(token));
            var userId = token.split(':')[0];
            if (userId) {
                _this.store.dispatch(new account.UserGetLanguage(token.split(':')[0]));
            }
        });
    };
    ResetPasswordContainer.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    ResetPasswordContainer.prototype.doSubmit = function (event) {
        this.store.dispatch(new account.Reset({ password: event.password, token: this.token }));
    };
    return ResetPasswordContainer;
}(ContainerBase));
export { ResetPasswordContainer };
